/* tslint:disable */
/* eslint-disable */
/**
 * CMS Content Model
 * This OpenAPI specification describes the content model of the CMS. This specification does not describe a micro service, as can be imagined due to the fact that the are no operations defined. Instead, this specification defines schemas, that may be used   * to be referenced in service   * to validate content objects against schemas   * to generate forms   * many more... Each schema is specified within it\'s own file. This approach has been chosen to facilitate reuse and lucidity. This all-in-one specification is provided for convenience.
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {DUMMY_BASE_URL, assertParamExists, setSearchParams, toPathString, createRequestFunction} from "./common";
// @ts-ignore
import {BASE_PATH, BaseAPI} from "./base";
export const AkeneoCategorySchemaEnum = {
  AkeneoCategory: "akeneo.Category"
};
export const AkeneoManufacturerSchemaEnum = {
  AkeneoManufacturer: "akeneo.Manufacturer"
};
export const AkeneoProductSchemaEnum = {
  AkeneoProduct: "akeneo.Product"
};
export const AppNodeSchemaEnum = {
  AppNode: "app.Node"
};
export const CmsBlockFooterSchemaEnum = {
  CmsBlockFooter: "cms.block.Footer"
};
export const CmsBlockFooterMenuSchemaEnum = {
  CmsComponentMenu: "cms.component.Menu"
};
export const CmsBlockFooterMenuActionSchemaEnum = {
  CmsComponentMenuAction: "cms.component.MenuAction"
};
export const CmsBlockFooterMenuActionCleansiteEnum = {
  Ggl: "ggl",
  Gglp: "gglp"
};
export const CmsBlockMenuSchemaEnum = {
  CmsBlockMenu: "cms.block.Menu"
};
export const CmsBrandSchemaEnum = {
  CmsBrand: "cms.Brand"
};
/**
 * Enumeration listing all colors referenceable by name.
 * @export
 * @enum {string}
 */
export const CmsColors = {
  Info: "info",
  Attention: "attention"
};
export const CmsComponentBannerSchemaEnum = {
  CmsComponentBanner: "cms.component.Banner"
};
export const CmsComponentDownloadsSchemaEnum = {
  CmsComponentDownloads: "cms.component.Downloads"
};
export const CmsComponentDownloadsAssetsInnerTargetEnum = {
  Blank: "_blank",
  Self: "_self"
};
export const CmsComponentEyecatcherSchemaEnum = {
  CmsComponentEyecatcher: "cms.component.Eyecatcher"
};
export const CmsComponentEyecatcherAppDownloadSchemaEnum = {
  CmsComponentEyecatcherAppDownload: "cms.component.EyecatcherAppDownload"
};
export const CmsComponentEyecatcherNewsletterSchemaEnum = {
  CmsComponentEyecatcherNewsletter: "cms.component.EyecatcherNewsletter"
};
export const CmsComponentEyecatcherProductNoveltySchemaEnum = {
  CmsComponentEyecatcherProductNovelty: "cms.component.EyecatcherProductNovelty"
};
export const CmsComponentEyecatcherProductRatingSchemaEnum = {
  CmsComponentEyecatcherProductRating: "cms.component.EyecatcherProductRating"
};
export const CmsComponentEyecatcherRedpointsSchemaEnum = {
  CmsComponentEyecatcherRedpoints: "cms.component.EyecatcherRedpoints"
};
export const CmsComponentEyecatcherRedpointsFeaturedProductSchemaEnum = {
  CmsComponentEyecatcherRedpointsFeaturedProduct: "cms.component.EyecatcherRedpointsFeaturedProduct"
};
export const CmsComponentEyecatcherRxSchemaEnum = {
  CmsComponentEyecatcherRx: "cms.component.EyecatcherRx"
};
export const CmsComponentEyecatcherTwoForOneSchemaEnum = {
  CmsComponentEyecatcherTwoForOne: "cms.component.EyecatcherTwoForOne"
};
export const CmsComponentFaqQuestionSchemaEnum = {
  CmsComponentFaqQuestion: "cms.component.FaqQuestion"
};
export const CmsComponentFaqSectionSchemaEnum = {
  CmsComponentFaqSection: "cms.component.FaqSection"
};
export const CmsComponentFaqTocSchemaEnum = {
  CmsComponentFaqToc: "cms.component.FaqToc"
};
export const CmsComponentGlossaryOverviewSchemaEnum = {
  CmsComponentGlossaryOverview: "cms.component.GlossaryOverview"
};
export const CmsComponentHeadingSchemaEnum = {
  CmsComponentHeading: "cms.component.Heading"
};
export const CmsComponentHtmlSchemaEnum = {
  CmsComponentHtml: "cms.component.Html"
};
export const CmsComponentImageBoxSchemaEnum = {
  CmsComponentImageBox: "cms.component.ImageBox"
};
export const CmsComponentInfoBoxSchemaEnum = {
  CmsComponentInfoBox: "cms.component.InfoBox"
};
export const CmsComponentKeyVisualSchemaEnum = {
  CmsComponentKeyVisual: "cms.component.KeyVisual"
};
export const CmsComponentLegacyBrandsSchemaEnum = {
  CmsComponentLegacyBrands: "cms.component.legacy.Brands"
};
export const CmsComponentLegacyCategorySmallSchemaEnum = {
  CmsComponentLegacyCategorySmall: "cms.component.legacy.CategorySmall"
};
export const CmsComponentLegacyCategoryWideSchemaEnum = {
  CmsComponentLegacyCategoryWide: "cms.component.legacy.CategoryWide"
};
export const CmsComponentLegacyCrossellSchemaEnum = {
  CmsComponentLegacyCrossell: "cms.component.legacy.Crossell"
};
export const CmsComponentLegacyCrossellLayoutEnum = {
  Slider: "slider",
  Multiline: "multiline"
};
export const CmsComponentLegacyDocumentsSchemaEnum = {
  CmsComponentLegacyDocuments: "cms.component.legacy.Documents"
};
export const CmsComponentLegacyHtmlSchemaEnum = {
  CmsComponentLegacyHtml: "cms.component.legacy.Html"
};
export const CmsComponentLegacyLinksSchemaEnum = {
  CmsComponentLegacyLinks: "cms.component.legacy.Links"
};
export const CmsComponentLegacyLinksEntryTargetEnum = {
  Blank: "_blank",
  Self: "_self"
};
export const CmsComponentLegacyMiddleBannerSchemaEnum = {
  CmsComponentLegacyMiddleBanner: "cms.component.legacy.MiddleBanner"
};
export const CmsComponentLegacyProductBatterySchemaEnum = {
  CmsComponentLegacyProductBattery: "cms.component.legacy.ProductBattery"
};
export const CmsComponentLegacyProductBatteryModusEnum = {
  Top: "top",
  Topsub: "topsub",
  Cat: "cat",
  Catsub: "catsub"
};
export const CmsComponentLegacyRatingsSchemaEnum = {
  CmsComponentLegacyRatings: "cms.component.legacy.Ratings"
};
export const CmsComponentLegacyVideosSchemaEnum = {
  CmsComponentLegacyVideos: "cms.component.legacy.Videos"
};
export const CmsComponentMenuSchemaEnum = {
  CmsComponentMenu: "cms.component.Menu"
};
export const CmsComponentMenuActionSchemaEnum = {
  CmsComponentMenuAction: "cms.component.MenuAction"
};
export const CmsComponentMenuActionCleansiteEnum = {
  Ggl: "ggl",
  Gglp: "gglp"
};
export const CmsComponentMenuSeparatorSchemaEnum = {
  CmsComponentMenuSeparator: "cms.component.MenuSeparator"
};
export const CmsComponentMenuSpacerSchemaEnum = {
  CmsComponentMenuSpacer: "cms.component.MenuSpacer"
};
export const CmsComponentOdsLinkoutSchemaEnum = {
  CmsComponentOdsLinkout: "cms.component.OdsLinkout"
};
export const CmsComponentProductHighlightsSchemaEnum = {
  CmsComponentProductHighlights: "cms.component.ProductHighlights"
};
export const CmsComponentProductHighlightsCtaModeEnum = {
  Go2product: "go2product",
  Add2cart: "add2cart",
  Go2productAdd2cart: "go2product_add2cart",
  ByEditor: "by_editor"
};
export const CmsComponentProductHighlightsProductBadgeModeEnum = {
  None: "none",
  Discount: "discount",
  NewProduct: "new_product",
  ByEditor: "by_editor"
};
export const CmsComponentProductRatingSchemaEnum = {
  CmsComponentProductRating: "cms.component.ProductRating"
};
export const CmsComponentProductRatingModeEnum = {
  Top: "top",
  Newest: "newest"
};
export const CmsComponentProductSliderSchemaEnum = {
  CmsComponentProductSlider: "cms.component.ProductSlider"
};
export const CmsComponentProductSliderModeEnum = {
  Top: "top",
  Topsub: "topsub",
  Cat: "cat",
  Catsub: "catsub"
};
export const CmsComponentQuickInfoBoxSchemaEnum = {
  CmsComponentQuickInfoBox: "cms.component.QuickInfoBox"
};
export const CmsComponentSearchTermsSchemaEnum = {
  CmsComponentSearchTerms: "cms.component.SearchTerms"
};
export const CmsComponentTableOfContentsSchemaEnum = {
  CmsComponentTableOfContents: "cms.component.TableOfContents"
};
export const CmsComponentTagCloudSchemaEnum = {
  CmsComponentTagCloud: "cms.component.TagCloud"
};
export const CmsComponentTextSchemaEnum = {
  CmsComponentText: "cms.component.Text"
};
export const CmsComponentTextAndImageSchemaEnum = {
  CmsComponentTextAndImage: "cms.component.TextAndImage"
};
export const CmsComponentTextAndImageAlignEnum = {
  Left: "left",
  Right: "right"
};
export const CmsComponentTextAndVideoSchemaEnum = {
  CmsComponentTextAndVideo: "cms.component.TextAndVideo"
};
export const CmsComponentTextAndVideoAlignEnum = {
  Left: "left",
  Right: "right"
};
export const CmsComponentTipSchemaEnum = {
  CmsComponentTip: "cms.component.Tip"
};
export const CmsComponentVideoBoxSchemaEnum = {
  CmsComponentVideoBox: "cms.component.VideoBox"
};
export const CmsComponentVideoSliderSchemaEnum = {
  CmsComponentVideoSlider: "cms.component.VideoSlider"
};
export const CmsComponentVoucherOnBrandSchemaEnum = {
  CmsComponentVoucherOnBrand: "cms.component.VoucherOnBrand"
};
export const CmsComponentVoucherOnProductSchemaEnum = {
  CmsComponentVoucherOnProduct: "cms.component.VoucherOnProduct"
};
export const CmsDataProviderPimProductOffersSchemaEnum = {
  PimProductOffers: "pim.ProductOffers"
};
export const CmsFragmentCallToActionTargetEnum = {
  Self: "_self",
  Blank: "_blank"
};
export const CmsFragmentImageSchemaEnum = {
  CmsFragmentImage: "cms.fragment.Image"
};
export const CmsFragmentImageTargetEnum = {
  Self: "_self",
  Blank: "_blank"
};
export const CmsGlossarySchemaEnum = {
  CmsGlossary: "cms.Glossary"
};
/**
 * Enumeration listing all icons referenceable by name.
 * @export
 * @enum {string}
 */
export const CmsIcons = {
  ArrowBreadcrumb: "arrowBreadcrumb",
  ArrowLeft: "arrowLeft",
  ArrowRight: "arrowRight",
  BabyBottle: "babyBottle",
  Beaker: "beaker",
  Bin: "bin",
  Blog: "blog",
  Calendar: "calendar",
  CaretDown: "caretDown",
  CaretLeft: "caretLeft",
  CaretRight: "caretRight",
  CaretUp: "caretUp",
  Cart: "cart",
  Certificate: "certificate",
  CircleCross: "circleCross",
  CircleExclamation: "circleExclamation",
  CircleHealth: "circleHealth",
  CircleInfo: "circleInfo",
  CirclePlay: "circlePlay",
  CircleStar: "circleStar",
  CircleStarFilled: "circleStarFilled",
  CircleTick: "circleTick",
  Clock: "clock",
  Cross: "cross",
  Delivery: "delivery",
  Dispenser: "dispenser",
  Document: "document",
  DocumentChecklist: "documentChecklist",
  DocumentInsert: "documentInsert",
  DocumentMultimedia: "documentMultimedia",
  Email: "email",
  EmailArrow: "emailArrow",
  Equals: "equals",
  Euro: "euro",
  Eye: "eye",
  EyeCross: "eyeCross",
  Facebook: "facebook",
  Gift: "gift",
  Hamburger: "hamburger",
  HealthCross: "healthCross",
  Heart: "heart",
  HeartFilled: "heartFilled",
  Home: "home",
  HomeTo: "homeTo",
  Leaf: "leaf",
  Location: "location",
  LocationHome: "locationHome",
  LocationMap: "locationMap",
  Lock: "lock",
  Mail: "mail",
  Message: "message",
  Minus: "minus",
  Notification: "notification",
  PackageList: "packageList",
  PackagePrice: "packagePrice",
  Paw: "paw",
  Pdf: "pdf",
  Pencil: "pencil",
  Pills: "pills",
  Pinterest: "pinterest",
  Plus: "plus",
  Prize: "prize",
  Profile: "profile",
  Redpoints: "redpoints",
  Refresh: "refresh",
  Search: "search",
  SendEnvelope: "sendEnvelope",
  Share: "share",
  ShareAlt: "shareAlt",
  Smartphone: "smartphone",
  Smiley: "smiley",
  StarEmpty: "starEmpty",
  StarFilled: "starFilled",
  Target: "target",
  Telephone: "telephone",
  Tick: "tick",
  Twitter: "twitter",
  Youtube: "youtube"
};
/**
 * Enumeration listing all tags referenceable by name.
 * @export
 * @enum {string}
 */
export const CmsMenuTags = {
  Expandable: "expandable",
  Highlighted: "highlighted"
};
export const CmsSearchFilterDiscountRangeSchemaEnum = {
  PimSearchFilterDiscountRange: "pim.SearchFilterDiscountRange"
};
export const CmsTemplateCategoryLeafSchemaEnum = {
  CmsTemplateCategoryLeaf: "cms.template.CategoryLeaf"
};
export const CmsTemplateFaqSchemaEnum = {
  CmsTemplateFaq: "cms.template.Faq"
};
export const CmsTemplateLegacySchemaEnum = {
  CmsTemplateLegacy: "cms.template.Legacy"
};
export const CmsTemplateMarketingSchemaEnum = {
  CmsTemplateMarketing: "cms.template.Marketing"
};
export const FockBlockSchemaEnum = {
  FockBlock: "fock.Block"
};
export const FockDirectSchemaEnum = {
  FockDirect: "fock.Direct"
};
/**
 * Enumeration listing all valid languages. To be reused within all schemas that are bound to a language.
 * @export
 * @enum {string}
 */
export const FockLanguages = {
  De: "de",
  Fr: "fr",
  It: "it"
};
export const FockNodeSchemaEnum = {
  FockNode: "fock.Node"
};
export const FockPageSchemaEnum = {
  FockPage: "fock.Page"
};
export const FockRedirectSchemaEnum = {
  FockRedirect: "fock.Redirect"
};
export const FockSeoMetaRobotsEnum = {
  Index: "index",
  Noindex: "noindex",
  Follow: "follow",
  Nofollow: "nofollow",
  IndexFollow: "index, follow",
  NoindexFollow: "noindex, follow",
  IndexNofollow: "index, nofollow",
  NoindexNofollow: "noindex, nofollow"
};
/**
 * Enumeration listing all valid tenants. To be reused within all schemas that are bound to a tenant. Note that tenants should use aliases (like COM) instead of DNS like names (e.g. shop-apotheke.com).
 * @export
 * @enum {string}
 */
export const FockTenants = {
  Com: "com",
  At: "at",
  Fr: "fr",
  It: "it",
  Es: "es",
  Ch: "ch",
  ComQs: "com-qs",
  AtQs: "at-qs",
  FrQs: "fr-qs",
  ItQs: "it-qs",
  EsQs: "es-qs",
  ChQs: "ch-qs"
};
export const MediaserverAssetSchemaEnum = {
  MediaserverAsset: "mediaserver.Asset"
};
export const PimProductSetsSchemaEnum = {
  PimProductSets: "pim.ProductSets"
};
export const PimProductsByCategorySchemaEnum = {
  PimProductsByCategory: "pim.ProductsByCategory"
};
export const PimProductsNoveltiesSchemaEnum = {
  PimProductsNovelties: "pim.ProductsNovelties"
};
export const PimProductsNowSchemaEnum = {
  PimProductsNow: "pim.ProductsNow"
};
export const VideoSchemaEnum = {
  _3qsdnVideo: "3qsdn.Video"
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /node/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /node/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appnodesTenantLanguagePathGet: (tenant, language, path, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("appnodesTenantLanguagePathGet", "tenant", tenant);
        // verify required parameter 'language' is not null or undefined
        assertParamExists("appnodesTenantLanguagePathGet", "language", language);
        // verify required parameter 'path' is not null or undefined
        assertParamExists("appnodesTenantLanguagePathGet", "path", path);
        const localVarPath = `/appnodes/{tenant}/{language}/{path}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"language"}}`, encodeURIComponent(String(language)))
          .replace(`{${"path"}}`, encodeURIComponent(String(path)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {FockTenants} tenant
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /node/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /node/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    appnodesTenantPathGet: (tenant, path, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("appnodesTenantPathGet", "tenant", tenant);
        // verify required parameter 'path' is not null or undefined
        assertParamExists("appnodesTenantPathGet", "path", path);
        const localVarPath = `/appnodes/{tenant}/{path}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"path"}}`, encodeURIComponent(String(path)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     * Provided for convenience. Consumers of this service should usually be fine when using the _GetBlocksByTenantAndLanguageAndCode_ operation
     * @summary Get a fock.Block
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBlocksByTenantAndLanguageAndCode: (tenant, language, code, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("getBlocksByTenantAndLanguageAndCode", "tenant", tenant);
        // verify required parameter 'language' is not null or undefined
        assertParamExists("getBlocksByTenantAndLanguageAndCode", "language", language);
        // verify required parameter 'code' is not null or undefined
        assertParamExists("getBlocksByTenantAndLanguageAndCode", "code", code);
        const localVarPath = `/blocks/{tenant}/{language}/{code}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"language"}}`, encodeURIComponent(String(language)))
          .replace(`{${"code"}}`, encodeURIComponent(String(code)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     * Provided for convenience. Consumers of this service should usually be fine when using the _GetRouteByTenantAndPath_ operation
     * @summary Get a fock.Page in packed JSON format
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPackedPageByTenantAndLocaleAndPath: (tenant, language, code, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("getPackedPageByTenantAndLocaleAndPath", "tenant", tenant);
        // verify required parameter 'language' is not null or undefined
        assertParamExists("getPackedPageByTenantAndLocaleAndPath", "language", language);
        // verify required parameter 'code' is not null or undefined
        assertParamExists("getPackedPageByTenantAndLocaleAndPath", "code", code);
        const localVarPath = `/packed/pages/{tenant}/{language}/{code}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"language"}}`, encodeURIComponent(String(language)))
          .replace(`{${"code"}}`, encodeURIComponent(String(code)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     * Provided for debug. Consumers of this service may use this method to evaluate possible problems with unpacking of _Fock_ packed JSON format. Due to the fact that there is currently no schema specified for the packed format, this endpoint returns arbitrary JSON.
     * @summary Get a fock.Direct or fock.Redirect route in packed JSON format
     * @param {FockTenants} tenant
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /route/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /route/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getPackedRouteByTenantAndPath: (tenant, path, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("getPackedRouteByTenantAndPath", "tenant", tenant);
        // verify required parameter 'path' is not null or undefined
        assertParamExists("getPackedRouteByTenantAndPath", "path", path);
        const localVarPath = `/packed/routes/{tenant}/{path}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"path"}}`, encodeURIComponent(String(path)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     * Provided for debug. Consumers of this service may use this method to evaluate possible problems with unpacking of _Fock_ packed JSON format. Due to the fact that there is currently no schema specified for the packed format, this endpoint returns arbitrary JSON.
     * @summary Get a fock.Direct or fock.Redirect route in packed JSON format
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /route/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /route/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPackedRouteByTenantLanguageAndPath: (tenant, language, path, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("getPackedRouteByTenantLanguageAndPath", "tenant", tenant);
        // verify required parameter 'language' is not null or undefined
        assertParamExists("getPackedRouteByTenantLanguageAndPath", "language", language);
        // verify required parameter 'path' is not null or undefined
        assertParamExists("getPackedRouteByTenantLanguageAndPath", "path", path);
        const localVarPath = `/packed/routes/{tenant}/{language}/{path}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"language"}}`, encodeURIComponent(String(language)))
          .replace(`{${"path"}}`, encodeURIComponent(String(path)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     * Provided for convenience. Consumers of this service should usually be fine when using the _GetPageByTenantAndLocaleAndPath_ operation
     * @summary Get a fock.Page
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPageByTenantAndLocaleAndPath: (tenant, language, code, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("getPageByTenantAndLocaleAndPath", "tenant", tenant);
        // verify required parameter 'language' is not null or undefined
        assertParamExists("getPageByTenantAndLocaleAndPath", "language", language);
        // verify required parameter 'code' is not null or undefined
        assertParamExists("getPageByTenantAndLocaleAndPath", "code", code);
        const localVarPath = `/pages/{tenant}/{language}/{code}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"language"}}`, encodeURIComponent(String(language)))
          .replace(`{${"code"}}`, encodeURIComponent(String(code)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     *
     * @summary Get a fock.Direct or fock.Redirect route
     * @param {FockTenants} tenant
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /routes/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /routes/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getRouteByTenantAndPath: (tenant, path, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("getRouteByTenantAndPath", "tenant", tenant);
        // verify required parameter 'path' is not null or undefined
        assertParamExists("getRouteByTenantAndPath", "path", path);
        const localVarPath = `/routes/{tenant}/{path}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"path"}}`, encodeURIComponent(String(path)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     *
     * @summary Get a fock.Direct or fock.Redirect route
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /routes/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /routes/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRouteByTenantLanguageAndPath: (tenant, language, path, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("getRouteByTenantLanguageAndPath", "tenant", tenant);
        // verify required parameter 'language' is not null or undefined
        assertParamExists("getRouteByTenantLanguageAndPath", "language", language);
        // verify required parameter 'path' is not null or undefined
        assertParamExists("getRouteByTenantLanguageAndPath", "path", path);
        const localVarPath = `/routes/{tenant}/{language}/{path}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"language"}}`, encodeURIComponent(String(language)))
          .replace(`{${"path"}}`, encodeURIComponent(String(path)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     *
     * @summary Get a category related tree node by it\'S category code.
     * @param {FockTenants} tenant
     * @param {string} code A category code as used within the PIM system. E.g. _csd00001_
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    nodesByCodeTenantCodeGet: (tenant, code, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("nodesByCodeTenantCodeGet", "tenant", tenant);
        // verify required parameter 'code' is not null or undefined
        assertParamExists("nodesByCodeTenantCodeGet", "code", code);
        const localVarPath = `/nodes-by-code/{tenant}/{code}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"code"}}`, encodeURIComponent(String(code)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     *
     * @summary Get a category related tree node by it\'s category code and language.
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} code A category code as used within the PIM system. E.g. _csd00001_
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodesByCodeTenantLanguageCodeGet: (tenant, language, code, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("nodesByCodeTenantLanguageCodeGet", "tenant", tenant);
        // verify required parameter 'language' is not null or undefined
        assertParamExists("nodesByCodeTenantLanguageCodeGet", "language", language);
        // verify required parameter 'code' is not null or undefined
        assertParamExists("nodesByCodeTenantLanguageCodeGet", "code", code);
        const localVarPath = `/nodes-by-code/{tenant}/{language}/{code}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"language"}}`, encodeURIComponent(String(language)))
          .replace(`{${"code"}}`, encodeURIComponent(String(code)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /node/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /node/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodesTenantLanguagePathGet: (tenant, language, path, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("nodesTenantLanguagePathGet", "tenant", tenant);
        // verify required parameter 'language' is not null or undefined
        assertParamExists("nodesTenantLanguagePathGet", "language", language);
        // verify required parameter 'path' is not null or undefined
        assertParamExists("nodesTenantLanguagePathGet", "path", path);
        const localVarPath = `/nodes/{tenant}/{language}/{path}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"language"}}`, encodeURIComponent(String(language)))
          .replace(`{${"path"}}`, encodeURIComponent(String(path)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      }),
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {FockTenants} tenant
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /node/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /node/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    nodesTenantPathGet: (tenant, path, options = {}) =>
      __awaiter(this, void 0, void 0, function* () {
        // verify required parameter 'tenant' is not null or undefined
        assertParamExists("nodesTenantPathGet", "tenant", tenant);
        // verify required parameter 'path' is not null or undefined
        assertParamExists("nodesTenantPathGet", "path", path);
        const localVarPath = `/nodes/{tenant}/{path}`
          .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
          .replace(`{${"path"}}`, encodeURIComponent(String(path)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }
        const localVarRequestOptions = Object.assign(Object.assign({method: "GET"}, baseOptions), options);
        const localVarHeaderParameter = {};
        const localVarQueryParameter = {};
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = Object.assign(
          Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
          options.headers
        );
        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions
        };
      })
  };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration) {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /node/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /node/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appnodesTenantLanguagePathGet(tenant, language, path, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.appnodesTenantLanguagePathGet(
          tenant,
          language,
          path,
          options
        );
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {FockTenants} tenant
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /node/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /node/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    appnodesTenantPathGet(tenant, path, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.appnodesTenantPathGet(tenant, path, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     * Provided for convenience. Consumers of this service should usually be fine when using the _GetBlocksByTenantAndLanguageAndCode_ operation
     * @summary Get a fock.Block
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBlocksByTenantAndLanguageAndCode(tenant, language, code, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getBlocksByTenantAndLanguageAndCode(
          tenant,
          language,
          code,
          options
        );
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     * Provided for convenience. Consumers of this service should usually be fine when using the _GetRouteByTenantAndPath_ operation
     * @summary Get a fock.Page in packed JSON format
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPackedPageByTenantAndLocaleAndPath(tenant, language, code, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPackedPageByTenantAndLocaleAndPath(
          tenant,
          language,
          code,
          options
        );
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     * Provided for debug. Consumers of this service may use this method to evaluate possible problems with unpacking of _Fock_ packed JSON format. Due to the fact that there is currently no schema specified for the packed format, this endpoint returns arbitrary JSON.
     * @summary Get a fock.Direct or fock.Redirect route in packed JSON format
     * @param {FockTenants} tenant
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /route/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /route/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getPackedRouteByTenantAndPath(tenant, path, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPackedRouteByTenantAndPath(tenant, path, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     * Provided for debug. Consumers of this service may use this method to evaluate possible problems with unpacking of _Fock_ packed JSON format. Due to the fact that there is currently no schema specified for the packed format, this endpoint returns arbitrary JSON.
     * @summary Get a fock.Direct or fock.Redirect route in packed JSON format
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /route/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /route/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPackedRouteByTenantLanguageAndPath(tenant, language, path, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPackedRouteByTenantLanguageAndPath(
          tenant,
          language,
          path,
          options
        );
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     * Provided for convenience. Consumers of this service should usually be fine when using the _GetPageByTenantAndLocaleAndPath_ operation
     * @summary Get a fock.Page
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPageByTenantAndLocaleAndPath(tenant, language, code, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getPageByTenantAndLocaleAndPath(
          tenant,
          language,
          code,
          options
        );
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     *
     * @summary Get a fock.Direct or fock.Redirect route
     * @param {FockTenants} tenant
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /routes/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /routes/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getRouteByTenantAndPath(tenant, path, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getRouteByTenantAndPath(tenant, path, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     *
     * @summary Get a fock.Direct or fock.Redirect route
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /routes/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /routes/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRouteByTenantLanguageAndPath(tenant, language, path, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getRouteByTenantLanguageAndPath(
          tenant,
          language,
          path,
          options
        );
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     *
     * @summary Get a category related tree node by it\'S category code.
     * @param {FockTenants} tenant
     * @param {string} code A category code as used within the PIM system. E.g. _csd00001_
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    nodesByCodeTenantCodeGet(tenant, code, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.nodesByCodeTenantCodeGet(tenant, code, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     *
     * @summary Get a category related tree node by it\'s category code and language.
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} code A category code as used within the PIM system. E.g. _csd00001_
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodesByCodeTenantLanguageCodeGet(tenant, language, code, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.nodesByCodeTenantLanguageCodeGet(
          tenant,
          language,
          code,
          options
        );
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {FockTenants} tenant
     * @param {FockLanguages} language
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /node/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /node/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodesTenantLanguagePathGet(tenant, language, path, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.nodesTenantLanguagePathGet(
          tenant,
          language,
          path,
          options
        );
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    },
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {FockTenants} tenant
     * @param {string} path A path as described within [RFC3986](https://tools.ietf.org/html/rfc3986), but **without** any leading or tailing slashes. Note that despite most routing frameworks used in common programming languages, OpenAPI currently only supports a subset of [URI Templates](https://tools.ietf.org/html/rfc6570). So by _spec_ the path parameter may not contain further slashes. However, micro-service implementations of this spec are encouraged to defy that fact (OpenAPI may fully support URI Templates soon). Hence to get a route at a path, consumers should simply adhere to the following examples. **Examples**   * /arzneimittel/ -&gt; /node/com/arzneimittel   * /nivea/nivea-visage/ -&gt; /node/com/nivea/nivea-visage
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    nodesTenantPathGet(tenant, path, options) {
      return __awaiter(this, void 0, void 0, function* () {
        const localVarAxiosArgs = yield localVarAxiosParamCreator.nodesTenantPathGet(tenant, path, options);
        return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
      });
    }
  };
};
/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
  const localVarFp = DefaultApiFp(configuration);
  return {
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {DefaultApiAppnodesTenantLanguagePathGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appnodesTenantLanguagePathGet(requestParameters, options) {
      return localVarFp
        .appnodesTenantLanguagePathGet(
          requestParameters.tenant,
          requestParameters.language,
          requestParameters.path,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {DefaultApiAppnodesTenantPathGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    appnodesTenantPathGet(requestParameters, options) {
      return localVarFp
        .appnodesTenantPathGet(requestParameters.tenant, requestParameters.path, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Provided for convenience. Consumers of this service should usually be fine when using the _GetBlocksByTenantAndLanguageAndCode_ operation
     * @summary Get a fock.Block
     * @param {DefaultApiGetBlocksByTenantAndLanguageAndCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBlocksByTenantAndLanguageAndCode(requestParameters, options) {
      return localVarFp
        .getBlocksByTenantAndLanguageAndCode(
          requestParameters.tenant,
          requestParameters.language,
          requestParameters.code,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Provided for convenience. Consumers of this service should usually be fine when using the _GetRouteByTenantAndPath_ operation
     * @summary Get a fock.Page in packed JSON format
     * @param {DefaultApiGetPackedPageByTenantAndLocaleAndPathRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPackedPageByTenantAndLocaleAndPath(requestParameters, options) {
      return localVarFp
        .getPackedPageByTenantAndLocaleAndPath(
          requestParameters.tenant,
          requestParameters.language,
          requestParameters.code,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Provided for debug. Consumers of this service may use this method to evaluate possible problems with unpacking of _Fock_ packed JSON format. Due to the fact that there is currently no schema specified for the packed format, this endpoint returns arbitrary JSON.
     * @summary Get a fock.Direct or fock.Redirect route in packed JSON format
     * @param {DefaultApiGetPackedRouteByTenantAndPathRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getPackedRouteByTenantAndPath(requestParameters, options) {
      return localVarFp
        .getPackedRouteByTenantAndPath(requestParameters.tenant, requestParameters.path, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Provided for debug. Consumers of this service may use this method to evaluate possible problems with unpacking of _Fock_ packed JSON format. Due to the fact that there is currently no schema specified for the packed format, this endpoint returns arbitrary JSON.
     * @summary Get a fock.Direct or fock.Redirect route in packed JSON format
     * @param {DefaultApiGetPackedRouteByTenantLanguageAndPathRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPackedRouteByTenantLanguageAndPath(requestParameters, options) {
      return localVarFp
        .getPackedRouteByTenantLanguageAndPath(
          requestParameters.tenant,
          requestParameters.language,
          requestParameters.path,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Provided for convenience. Consumers of this service should usually be fine when using the _GetPageByTenantAndLocaleAndPath_ operation
     * @summary Get a fock.Page
     * @param {DefaultApiGetPageByTenantAndLocaleAndPathRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPageByTenantAndLocaleAndPath(requestParameters, options) {
      return localVarFp
        .getPageByTenantAndLocaleAndPath(
          requestParameters.tenant,
          requestParameters.language,
          requestParameters.code,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a fock.Direct or fock.Redirect route
     * @param {DefaultApiGetRouteByTenantAndPathRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getRouteByTenantAndPath(requestParameters, options) {
      return localVarFp
        .getRouteByTenantAndPath(requestParameters.tenant, requestParameters.path, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a fock.Direct or fock.Redirect route
     * @param {DefaultApiGetRouteByTenantLanguageAndPathRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRouteByTenantLanguageAndPath(requestParameters, options) {
      return localVarFp
        .getRouteByTenantLanguageAndPath(
          requestParameters.tenant,
          requestParameters.language,
          requestParameters.path,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a category related tree node by it\'S category code.
     * @param {DefaultApiNodesByCodeTenantCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    nodesByCodeTenantCodeGet(requestParameters, options) {
      return localVarFp
        .nodesByCodeTenantCodeGet(requestParameters.tenant, requestParameters.code, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a category related tree node by it\'s category code and language.
     * @param {DefaultApiNodesByCodeTenantLanguageCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodesByCodeTenantLanguageCodeGet(requestParameters, options) {
      return localVarFp
        .nodesByCodeTenantLanguageCodeGet(
          requestParameters.tenant,
          requestParameters.language,
          requestParameters.code,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {DefaultApiNodesTenantLanguagePathGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nodesTenantLanguagePathGet(requestParameters, options) {
      return localVarFp
        .nodesTenantLanguagePathGet(
          requestParameters.tenant,
          requestParameters.language,
          requestParameters.path,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a tree node at the given path.
     * @param {DefaultApiNodesTenantPathGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    nodesTenantPathGet(requestParameters, options) {
      return localVarFp
        .nodesTenantPathGet(requestParameters.tenant, requestParameters.path, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
  /**
   *
   * @summary Get a tree node at the given path.
   * @param {DefaultApiAppnodesTenantLanguagePathGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  appnodesTenantLanguagePathGet(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .appnodesTenantLanguagePathGet(
        requestParameters.tenant,
        requestParameters.language,
        requestParameters.path,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get a tree node at the given path.
   * @param {DefaultApiAppnodesTenantPathGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  appnodesTenantPathGet(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .appnodesTenantPathGet(requestParameters.tenant, requestParameters.path, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Provided for convenience. Consumers of this service should usually be fine when using the _GetBlocksByTenantAndLanguageAndCode_ operation
   * @summary Get a fock.Block
   * @param {DefaultApiGetBlocksByTenantAndLanguageAndCodeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getBlocksByTenantAndLanguageAndCode(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .getBlocksByTenantAndLanguageAndCode(
        requestParameters.tenant,
        requestParameters.language,
        requestParameters.code,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Provided for convenience. Consumers of this service should usually be fine when using the _GetRouteByTenantAndPath_ operation
   * @summary Get a fock.Page in packed JSON format
   * @param {DefaultApiGetPackedPageByTenantAndLocaleAndPathRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getPackedPageByTenantAndLocaleAndPath(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .getPackedPageByTenantAndLocaleAndPath(
        requestParameters.tenant,
        requestParameters.language,
        requestParameters.code,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Provided for debug. Consumers of this service may use this method to evaluate possible problems with unpacking of _Fock_ packed JSON format. Due to the fact that there is currently no schema specified for the packed format, this endpoint returns arbitrary JSON.
   * @summary Get a fock.Direct or fock.Redirect route in packed JSON format
   * @param {DefaultApiGetPackedRouteByTenantAndPathRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getPackedRouteByTenantAndPath(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .getPackedRouteByTenantAndPath(requestParameters.tenant, requestParameters.path, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Provided for debug. Consumers of this service may use this method to evaluate possible problems with unpacking of _Fock_ packed JSON format. Due to the fact that there is currently no schema specified for the packed format, this endpoint returns arbitrary JSON.
   * @summary Get a fock.Direct or fock.Redirect route in packed JSON format
   * @param {DefaultApiGetPackedRouteByTenantLanguageAndPathRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getPackedRouteByTenantLanguageAndPath(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .getPackedRouteByTenantLanguageAndPath(
        requestParameters.tenant,
        requestParameters.language,
        requestParameters.path,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Provided for convenience. Consumers of this service should usually be fine when using the _GetPageByTenantAndLocaleAndPath_ operation
   * @summary Get a fock.Page
   * @param {DefaultApiGetPageByTenantAndLocaleAndPathRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getPageByTenantAndLocaleAndPath(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .getPageByTenantAndLocaleAndPath(
        requestParameters.tenant,
        requestParameters.language,
        requestParameters.code,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get a fock.Direct or fock.Redirect route
   * @param {DefaultApiGetRouteByTenantAndPathRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getRouteByTenantAndPath(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .getRouteByTenantAndPath(requestParameters.tenant, requestParameters.path, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get a fock.Direct or fock.Redirect route
   * @param {DefaultApiGetRouteByTenantLanguageAndPathRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getRouteByTenantLanguageAndPath(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .getRouteByTenantLanguageAndPath(
        requestParameters.tenant,
        requestParameters.language,
        requestParameters.path,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get a category related tree node by it\'S category code.
   * @param {DefaultApiNodesByCodeTenantCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  nodesByCodeTenantCodeGet(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .nodesByCodeTenantCodeGet(requestParameters.tenant, requestParameters.code, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get a category related tree node by it\'s category code and language.
   * @param {DefaultApiNodesByCodeTenantLanguageCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  nodesByCodeTenantLanguageCodeGet(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .nodesByCodeTenantLanguageCodeGet(
        requestParameters.tenant,
        requestParameters.language,
        requestParameters.code,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get a tree node at the given path.
   * @param {DefaultApiNodesTenantLanguagePathGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  nodesTenantLanguagePathGet(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .nodesTenantLanguagePathGet(requestParameters.tenant, requestParameters.language, requestParameters.path, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get a tree node at the given path.
   * @param {DefaultApiNodesTenantPathGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  nodesTenantPathGet(requestParameters, options) {
    return DefaultApiFp(this.configuration)
      .nodesTenantPathGet(requestParameters.tenant, requestParameters.path, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
